/**
 * Keep the dispatch promise and status badge in sync with the chosen variant.
 * This theme already fetches and broadcasts fresh server-rendered variant HTML.
 * We reuse that response rather than maintaining a second inventory calculation.
 */
if (!window.__spBlackFridayStockListener) {
  window.__spBlackFridayStockListener = true;
  document.addEventListener('variant:update', (event) => {
    const html = event.detail?.data?.html;
    const productId = String(event.detail?.data?.productId ?? '');
    if (!html || !productId || typeof html.querySelector !== 'function') return;

    const current = document.querySelector('[data-product-shipping-timing][data-product-id="' + productId + '"]');
    const incoming = html.querySelector('[data-product-shipping-timing][data-product-id="' + productId + '"]');
    if (!current || !incoming) return;

    // Shopify's fetched section is authoritative for the new variant's inventory.
    current.replaceWith(incoming.cloneNode(true));

    const currentBadge = document.querySelector('.product-details__direct-panel .sp-product-status-eyebrow');
    const nextBadge = html.querySelector('.product-details__direct-panel .sp-product-status-eyebrow');
    if (currentBadge && nextBadge) {
      currentBadge.replaceWith(nextBadge.cloneNode(true));
    }
  });
}
